import {
  BlankSlate,
  BlankSlateDescription,
  BlankSlateIcon,
  BlankSlateTitle,
  Box,
  Button,
  FileUploadButton,
} from "@prismicio/editor-ui"
import type { ReactNode } from "react"

import { useIsEmptyMediaLibrary } from "../hooks/useIsEmptyMediaLibrary"
import { useMediaLibrary } from "./MediaLibraryContext"

export function EmptyMediaList() {
  return useIsEmptyMediaLibrary() ? <EmptyLibrary /> : <NoSearchResults />
}

interface EmptyMediaListLayoutProps {
  children: ReactNode
}

function EmptyMediaListLayout(props: EmptyMediaListLayoutProps) {
  const { children } = props

  return (
    <Box justifyContent="center" flexDirection="column" height="100%">
      {children}
    </Box>
  )
}

export function NoSearchResults() {
  return (
    <EmptyMediaListLayout>
      <BlankSlate>
        <BlankSlateIcon
          name="close"
          lineColor="purple10"
          backgroundColor="purple3"
          borderColor="purple6"
          borderStyle="dashed"
          size="xlarge"
        />
        <BlankSlateTitle size="big">Oops!</BlankSlateTitle>
        <BlankSlateDescription width={360}>
          No items found matching your search
        </BlankSlateDescription>
      </BlankSlate>
    </EmptyMediaListLayout>
  )
}

function EmptyLibrary() {
  const { onFilesUpload } = useMediaLibrary()

  return (
    <EmptyMediaListLayout>
      <Box gap={20} flexDirection="column" alignItems="center">
        <Box maxWidth={375}>
          <BlankSlateTitle size="big">
            Start by uploading your files!
          </BlankSlateTitle>
        </Box>

        <Box
          border
          borderStyle="dashed"
          borderRadius={4}
          justifyContent="center"
        >
          <BlankSlate
            sx={{
              marginBlock: 80,
              marginInline: 48,
            }}
          >
            <BlankSlateIcon
              name="cloudUpload"
              lineColor="purple11"
              backgroundColor="purple5"
              size="large"
            />
            <BlankSlateTitle>
              Drop your files anywhere to upload or ...
            </BlankSlateTitle>
            <FileUploadButton
              onFilesSelected={onFilesUpload}
              renderButton={(onClick) => (
                <Box display="inline-flex" as="span">
                  <Button onClick={onClick} color="grey">
                    Upload media
                  </Button>
                </Box>
              )}
            />
            <BlankSlateDescription>
              Maximum upload size file: 128 MB
            </BlankSlateDescription>
          </BlankSlate>
        </Box>
      </Box>
    </EmptyMediaListLayout>
  )
}
